import {ClientRect, CollisionDetection, pointerWithin, rectIntersection} from '@dnd-kit/core';
import {Coordinates} from '@dnd-kit/utilities';
import {match, Pattern} from 'ts-pattern';

import {isNonEmptyArray} from 'ramda-adjunct';

const isInPointerRow = (rect: ClientRect, pointer: Coordinates) =>
  pointer.y >= rect.top && pointer.y <= rect.bottom;

export const dashboardCollisionDetection: CollisionDetection = (args) => {
  const {active, pointerCoordinates} = args;
  const droppableContainers = args.droppableContainers.filter(
    (candidate) => candidate.id !== active.id
  );
  const candidateArgs = {...args, droppableContainers};
  const pointerCollisions = pointerWithin(candidateArgs);

  return match({
    hasPointerCollisions: isNonEmptyArray(pointerCollisions),
    pointer: pointerCoordinates,
  })
    .with({hasPointerCollisions: true}, () => pointerCollisions)
    .with({pointer: Pattern.nonNullable}, ({pointer}) =>
      rectIntersection({
        ...candidateArgs,
        droppableContainers: droppableContainers.filter((candidate) =>
          match(args.droppableRects.get(candidate.id))
            .with(Pattern.nonNullable, (rect) => isInPointerRow(rect, pointer))
            .otherwise(() => false)
        ),
      })
    )
    .otherwise(() => []);
};
